import { render, staticRenderFns } from "./MarketingDashboardView.vue?vue&type=template&id=23437a74&scoped=true"
import script from "./MarketingDashboardView.vue?vue&type=script&lang=js"
export * from "./MarketingDashboardView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23437a74",
  null
  
)

export default component.exports